import styled from 'styled-components';

export const Container = styled.h2`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin: 0;
  padding: 0;
`;
